import ProductPageDescription from './product-page-description';
export default ProductPageDescription;